<template>
  <v-container fluid class="bg-gray">
    <v-layout row align-center>
      <v-flex>
        <v-card>
          <img
            :src="require('images/99icon_black.svg')"
            alt="Logo: 99Empresas"
          />
          <h1>A plataforma está temporariamente indisponível.</h1>
          <p>
            Mas fique tranquilo,
            <strong>seus colaboradores podem continuar usando o voucher corporativo normalmente</strong>. Estamos trabalhando para resolver o problema e em algumas horas a plataforma voltará a funcionar.
          </p>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'UnavailablePage'
}
</script>
<style lang="scss" scoped>
.bg-gray {
  background-color: #f6f6f6;
}

.layout {
  height: 100%;
  justify-content: center;
  align-content: center;

  .flex {
    height: auto;
  }
}

.v-card {
  max-width: 380px;
  max-height: 282px;
  margin: auto;
  border: 1px solid #e5e5e5 !important;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: none !important;
  padding: 62px 24px 24px;
  img {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -32px;
    margin-top: -37px;
  }

  h1 {
    color: #1a1b1a;
    font-family: "Montserrat", sans-serif;
    font-size: 20px;
    font-weight: 800;
    line-height: 27px;
    margin-bottom: 14px;
  }

  p {
    color: #757575;
    font-family: "Work Sans";
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
